import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';

import { getHasUbsDomain, getIsUbsEmail } from 'containers/authorization/selectors';
import Bankenverband from 'assets/svg/Bankenverband';
import SwissLife from 'assets/svg/SwissLife';
import { ReactComponent as UbsLogo } from 'assets/svg/ubsLogo.svg';

import { Container, P } from './styles';

const Sponsors = () => {
  const { t } = useTranslation('app');
  const isUbsEmail = useSelector(getIsUbsEmail);
  const hasUBSdomain = useSelector(getHasUbsDomain);
  const matchRegistration = useMatch('/registrieren');
  const mathUbs = useMatch('/ubs');
  const isUbs = isUbsEmail || (matchRegistration && hasUBSdomain) || mathUbs;

  return (
    <Container>
      {isUbs ? (
        <>
          <P>{t('UBS slogan')}</P>
          <a target="_blank" href="https://zuercher-bankenverband.ch" rel="noreferrer" aria-label="zuercher-bankenverband">
            <UbsLogo />
          </a>
        </>
      ) : (
        <>
          <P>{t('Sponsors')}</P>
          <a target="_blank" href="https://zuercher-bankenverband.ch" rel="noreferrer" aria-label="zuercher-bankenverband">
            <Bankenverband />
          </a>
          <a target="_blank" href="https://www.swisslife.ch" rel="noreferrer" aria-label="swisslife">
            <SwissLife />
          </a>
        </>
      )}
    </Container>
  );
};

export default Sponsors;
